import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { toast } from "sonner";
import { GraduationCap } from "@phosphor-icons/react";

export default function Login() {
  const nav = useNavigate();
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const quickFill = (e, p) => { setEmail(e); setPassword(p); };

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await login(email, password);
      toast.success(`Welcome, ${u.full_name}`);
      nav(u.role === "admin" ? "/admin" : u.role === "teacher" ? "/teacher" : "/student");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Login failed");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex">
      <div className="hidden md:flex md:w-1/2 bg-forest text-ivory relative overflow-hidden">
        <img src="https://images.unsplash.com/photo-1759093886545-ad615b17ce46?crop=entropy&cs=srgb&fm=jpg&w=1400&q=80" alt="campus" className="absolute inset-0 w-full h-full object-cover opacity-30" />
        <div className="relative z-10 p-16 flex flex-col justify-between w-full">
          <div className="flex items-center gap-2">
            <GraduationCap size={24} weight="duotone" className="text-ochre" />
            <span className="overline text-ivory/80">ControlEra</span>
          </div>
          <div>
            <h2 className="font-serif text-5xl leading-tight">"A mind once stretched by a new idea never returns to its original dimensions."</h2>
            <p className="mt-6 text-ivory/70 font-mono text-xs">— Oliver Wendell Holmes</p>
          </div>
          <div className="text-xs text-ivory/60">© 2026 ControlEra Academy LMS</div>
        </div>
      </div>

      <div className="flex-1 flex items-center justify-center p-8 bg-bone">
        <div className="w-full max-w-sm">
          <div className="overline mb-2">Sign in</div>
          <h1 className="font-serif text-4xl text-forest mb-8">Return to your academy.</h1>

          <form onSubmit={submit} className="space-y-4">
            <div>
              <label className="overline block mb-2">Email</label>
              <input value={email} onChange={(e) => setEmail(e.target.value)} type="email" required data-testid="login-email"
                className="w-full bg-ivory border border-stone px-4 py-3 focus:outline-none focus:ring-2 focus:ring-terracotta" />
            </div>
            <div>
              <label className="overline block mb-2">Password</label>
              <input value={password} onChange={(e) => setPassword(e.target.value)} type="password" required data-testid="login-password"
                className="w-full bg-ivory border border-stone px-4 py-3 focus:outline-none focus:ring-2 focus:ring-terracotta" />
            </div>
            <button disabled={loading} className="btn-primary w-full" data-testid="login-submit">{loading ? "Signing in…" : "Sign in"}</button>
          </form>

          <div className="mt-8 p-4 border border-stone bg-ivory">
            <div className="overline mb-2">Demo accounts</div>
            <div className="space-y-1 text-xs font-mono">
              <button type="button" onClick={() => quickFill("admin@lms.com", "admin123")} className="block w-full text-left hover:text-terracotta" data-testid="demo-admin">admin@lms.com / admin123</button>
              <button type="button" onClick={() => quickFill("teacher@lms.com", "teacher123")} className="block w-full text-left hover:text-terracotta" data-testid="demo-teacher">teacher@lms.com / teacher123</button>
              <button type="button" onClick={() => quickFill("student@lms.com", "student123")} className="block w-full text-left hover:text-terracotta" data-testid="demo-student">student@lms.com / student123</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
